import { z } from 'zod/v4';
export const ok = (data) => {
    return {
        ok: true,
        data,
    };
};
export const error = (error) => {
    return {
        ok: false,
        error,
    };
};
export const isOk = (result) => {
    return result.ok;
};
export const isError = (result) => {
    return !result.ok;
};
export const toResultFn = (fn) => (...args) => {
    try {
        const res = fn(...args);
        return ok(res);
    }
    catch (err) {
        return error(err);
    }
};
export const toAsyncResultFn = (fn) => async (...args) => {
    try {
        const res = await fn(...args);
        return ok(res);
    }
    catch (err) {
        return error(err);
    }
};
export const tryCatch = async (promise) => {
    try {
        return ok(await promise);
    }
    catch (err) {
        return error(err);
    }
};
export const map = (r, fn) => {
    if (r.ok) {
        return ok(fn(r.data));
    }
    return r;
};
export const mapError = (r, fn) => {
    if (!r.ok) {
        return error(fn(r.error));
    }
    return r;
};
export const apply = (r, fn) => {
    if (r.ok) {
        return fn(r.data);
    }
    return r;
};
export const ResultSchema = (data, error) => z.discriminatedUnion('ok', [
    z.object({ ok: z.literal(true), data: data }),
    z.object({ ok: z.literal(false), error: error }),
]);
//# sourceMappingURL=result.js.map